// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    background-color: #3275c3; /* React Native default blue color */
    padding-top: 120px; /* Add padding from the top */
    width: 200px; /* Set the width of the sidebar */
    height: 100vh; /* Set the height of the sidebar to fill the viewport */
    position: fixed; /* Position the sidebar fixed to the viewport */
    left: 0; /* Align the sidebar to the left */
    top: 0; /* Align the sidebar to the top */
  }
  
  .sidebar h2 {
    color: #fff; /* Set text color */
    padding-left: 20px; /* Add left padding */
  }
  
  .sidebar ul {
    list-style-type: none; /* Remove default list styles */
    padding: 0;
  }
  
  .sidebar ul li {
    padding: 10px 20px; /* Add padding to each list item */
  }
  
  .sidebar ul li a {
    color: #fff; /* Set link color */
    text-decoration: none;
    font-weight: bold; /* Make the items bold */
    display: block; /* Ensure full width of the link for hover effect */
    transition: background-color 0.3s ease; /* Add transition effect */
  }
  
  .sidebar ul li a:hover {
    background-color: #888686; /* Dark gray color on hover */
    cursor: pointer;
    padding: 5px 5px; /* Add extra padding on hover */
    border-radius: 5px; /* Add rounded corners */
  }
  
  .sidebar ul li a:active {
    background-color: #888686; /* Dark gray color on hover */
    cursor: pointer;
    padding: 5px 5px; /* Add extra padding on hover */
    border-radius: 5px; 
  }
  
  .sidebar ul li a:focus {
    background-color: #888686; /* Dark gray color on hover */
    cursor: pointer;
    padding: 5px 5px; /* Add extra padding on hover */
    border-radius: 5px; 
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Sidebar/SidebarStyle.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB,EAAE,oCAAoC;IAC/D,kBAAkB,EAAE,6BAA6B;IACjD,YAAY,EAAE,iCAAiC;IAC/C,aAAa,EAAE,uDAAuD;IACtE,eAAe,EAAE,+CAA+C;IAChE,OAAO,EAAE,kCAAkC;IAC3C,MAAM,EAAE,iCAAiC;EAC3C;;EAEA;IACE,WAAW,EAAE,mBAAmB;IAChC,kBAAkB,EAAE,qBAAqB;EAC3C;;EAEA;IACE,qBAAqB,EAAE,+BAA+B;IACtD,UAAU;EACZ;;EAEA;IACE,kBAAkB,EAAE,kCAAkC;EACxD;;EAEA;IACE,WAAW,EAAE,mBAAmB;IAChC,qBAAqB;IACrB,iBAAiB,EAAE,wBAAwB;IAC3C,cAAc,EAAE,mDAAmD;IACnE,sCAAsC,EAAE,0BAA0B;EACpE;;EAEA;IACE,yBAAyB,EAAE,6BAA6B;IACxD,eAAe;IACf,gBAAgB,EAAE,+BAA+B;IACjD,kBAAkB,EAAE,wBAAwB;EAC9C;;EAEA;IACE,yBAAyB,EAAE,6BAA6B;IACxD,eAAe;IACf,gBAAgB,EAAE,+BAA+B;IACjD,kBAAkB;EACpB;;EAEA;IACE,yBAAyB,EAAE,6BAA6B;IACxD,eAAe;IACf,gBAAgB,EAAE,+BAA+B;IACjD,kBAAkB;EACpB","sourcesContent":[".sidebar {\n    background-color: #3275c3; /* React Native default blue color */\n    padding-top: 120px; /* Add padding from the top */\n    width: 200px; /* Set the width of the sidebar */\n    height: 100vh; /* Set the height of the sidebar to fill the viewport */\n    position: fixed; /* Position the sidebar fixed to the viewport */\n    left: 0; /* Align the sidebar to the left */\n    top: 0; /* Align the sidebar to the top */\n  }\n  \n  .sidebar h2 {\n    color: #fff; /* Set text color */\n    padding-left: 20px; /* Add left padding */\n  }\n  \n  .sidebar ul {\n    list-style-type: none; /* Remove default list styles */\n    padding: 0;\n  }\n  \n  .sidebar ul li {\n    padding: 10px 20px; /* Add padding to each list item */\n  }\n  \n  .sidebar ul li a {\n    color: #fff; /* Set link color */\n    text-decoration: none;\n    font-weight: bold; /* Make the items bold */\n    display: block; /* Ensure full width of the link for hover effect */\n    transition: background-color 0.3s ease; /* Add transition effect */\n  }\n  \n  .sidebar ul li a:hover {\n    background-color: #888686; /* Dark gray color on hover */\n    cursor: pointer;\n    padding: 5px 5px; /* Add extra padding on hover */\n    border-radius: 5px; /* Add rounded corners */\n  }\n  \n  .sidebar ul li a:active {\n    background-color: #888686; /* Dark gray color on hover */\n    cursor: pointer;\n    padding: 5px 5px; /* Add extra padding on hover */\n    border-radius: 5px; \n  }\n  \n  .sidebar ul li a:focus {\n    background-color: #888686; /* Dark gray color on hover */\n    cursor: pointer;\n    padding: 5px 5px; /* Add extra padding on hover */\n    border-radius: 5px; \n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
